import React, { useEffect, useState } from "react";

import api from "../../../api";
import CourseSelector from "../../../components/CourseSelector/CourseSelector";
import FilteredCurriculum from "../../../components/FilteredCurriculum/FilteredCurriculum";
import QuestionnaireForm from "../../../components/QuestionnaireForm/QuestionnaireForm";
import DisplayMarks from "../../../components/DisplayMarks.jsx/DisplayMarks";
import TermworkAttainmentSaveToDatabase from "../../../components/CalculateAttainment/TermworkAttainmentSaveToDatabase";

const excludedCurriculumIds = [3,16];
const TheoryCurriculumIds = [1, 2];
const noCurriculumIds = [18];
const TermworkUpload = ({ uid }) => {
  const [curriculum, setCurriculum] = useState(null);
  const [termworkTable, setTermworkTable] = useState(null);
  const [termworkCurriculum, setTermworkCurriculum] = useState(null);
  const [filteredCurriculum, setFilteredCurriculum] = useState(null);
  const [selectedTwid, setSelectedTwid] = useState(1); // Default twid for selection
  const [userCourseId, setUserCourseId] = useState(null);
  const [twdata, setTwData] = useState(null);
  const [selectedCurriculumId, setSelectedCurriculumId] = useState(null);

  const handleSelect = (id) => {
    setSelectedCurriculumId(id);
    console.log(`Selected ID: ${id}`);
  };
  useEffect(() => {
    const fetchTermworkData = async () => {
      try {
        const response = await api.get(`/api/termwork/getcurriculum`);
        const response2 = await api.get(`/api/termwork/get-termwork-table`);
        setCurriculum(response.data);
        setTermworkTable(response2.data);
      } catch (error) {
        console.error("Error fetching termwork data:", error);
        setCurriculum(null);
        setTermworkTable(null);
      }
    };

    fetchTermworkData();
  }, []);

  useEffect(() => {
    const fetchTermworkLabels = async () => {
      try {
        const response = await api.get(
          `/api/termwork/gettermworkdata/${userCourseId}`
        );
    
        setSelectedTwid(response.data[0]?.twid || 1); // Set default if no data
      } catch (error) {
        console.error("Error fetching termwork labels:", error);
      }
    };

    if (userCourseId) {
      fetchTermworkLabels();
    } else {
      setSelectedTwid(null);
      setFilteredCurriculum(null);
    }
  }, [userCourseId]);

  useEffect(() => {
    if (userCourseId && curriculum && termworkTable) {
      const selectedTermwork = termworkTable.find(
        (item) => item.twid === selectedTwid
      );
      if (selectedTermwork) {
        const includedIds = [];

        if (selectedTermwork.th_only_id) includedIds.push(1, 2, 3); // Theory Only
        if (selectedTermwork.miniproject) includedIds.push(4); // Mini Project (Alternative)
        if (selectedTermwork.majorproject) includedIds.push(5); // Major Project

        if (selectedTermwork.assignid) includedIds.push(6); // Assignment
        if (selectedTermwork.exid) includedIds.push(7); // Experiment
        if (selectedTermwork.scprid) includedIds.push(8); // Scilab
        if (selectedTermwork.report_id) includedIds.push(9); // Report

        if (selectedTermwork.ppt_id) includedIds.push(10); // PPT
        if (selectedTermwork.oralpce) includedIds.push(11); // Oral PCE
        if (selectedTermwork.mini_id) includedIds.push(12); // Mini Project
        if (selectedTermwork.miniproid) includedIds.push(13); // Mini Pro

        if (selectedTermwork.journalid) includedIds.push(14); // Journal
        if (selectedTermwork.tradeid) includedIds.push(15); // Trade

        if (selectedTermwork.oral) includedIds.push(16); // Oral
        if (selectedTermwork.attid) includedIds.push(18); // Attendance

        const filtered = curriculum.filter((item) =>
          includedIds.includes(item.idcurriculum)
        );

        const termwork = filtered.filter(
          (item) =>
            !excludedCurriculumIds.includes(item.idcurriculum) &&
            !TheoryCurriculumIds.includes(item.idcurriculum) &&
            !noCurriculumIds.includes(item.idcurriculum)
        );

        setFilteredCurriculum(filtered);
        setTermworkCurriculum(termwork);
      }
    } else {
      setFilteredCurriculum(null);
    }
  }, [userCourseId, selectedTwid, curriculum, termworkTable]);

  return (
    <div className="left-0 z-45 w-full mt-8">
      <h1 className="text-2xl font-bold mb-6 text-center">Upload Termwork</h1>
      <div className="flex justify-center mb-6">
        <div className="w-full max-w-lg md:max-w-2xl lg:max-w-3xl">
          <div className="bg-white shadow-lg rounded-xl p-6 border border-gray-200">
            <CourseSelector uid={uid} onUserCourseIdChange={setUserCourseId} />
          </div>
        </div>
      </div>
      <h2 className="text-xl font-semibold mt-6 mb-4 text-center">
        Filtered Curriculum:
      </h2>
      <FilteredCurriculum
        filteredCurriculum={filteredCurriculum}
        selectedCurriculumId={selectedCurriculumId}
        onSelect={handleSelect}
      />

      <div>
        {selectedCurriculumId && (
          <DisplayMarks
            filteredCurriculum={filteredCurriculum}
            userCourseId={userCourseId}
            selectedCurriculumId={selectedCurriculumId}
          />
        )}

{termworkCurriculum &&
  termworkCurriculum.some((curriculum) => selectedCurriculumId === curriculum.idcurriculum) && (
    <TermworkAttainmentSaveToDatabase
      termworkCurriculum={termworkCurriculum}
      userCourseId={userCourseId}
    />
  )}

      </div>
    </div>
  );
};

export default TermworkUpload;
